module.exports = __webpack_public_path__ + "static/img/PCKEFU.d3ccc878.jpg";